<template>
    <div class="search-container">
        <div class="field has-addons">
            <div class="control">
                <input class="input"
                       type="text"
                       placeholder="Søg studerende"
                       v-model="searchTerm"
                       @input="search">
            </div>
            <div class="control">
                <button class="button is-info"
                        @click="submit">
                    Søg
                </button>
            </div>
        </div>
        <div v-if="searchTerm && results.length && results.length <= 5"
             class="results-list">
            <router-link v-for="(result, index) in results.slice(0, 5)"
                         :key="index"
                         :to="{ name: 'students.profile', params: { slug: result.slug } }">
                <span class="result-item"> {{ result.name }}</span>
            </router-link>
        </div>
        <div v-if="searchTerm && results.length > 5"
             class="results-list">
            <p class="result-item">Mere end 5 personer fundet - indsnævr din søgning</p>
        </div>
        <div v-if="searchTerm && !results.length"
             class="results-list">
            <p class="result-item">Intet fundet</p>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ['students'],
    data() {
        return {
            searchTerm: "",
            results: [],
        };
    },
    methods: {
        search() {
            if (this.searchTerm === '') {
                this.results = [];
            } else {
                const term = this.searchTerm.toLowerCase();
                this.results = this.students.filter(student => student.name.toLowerCase().includes(term));
            }
        },
        submit() {
            this.search();
        },
    },
};
</script>
<style>
.search-container {
    position: relative;
}

.results-list {
    position: absolute;
    z-index: 1;
    background: white;
    border: 1px solid #ccc;
    margin-top: 10px;
    max-width: 350px;
    width: 100%;
}

.result-item {
    display: block;
    padding: 10px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.result-item:hover {
    background: lightgray;
}
</style>


// WEBPACK FOOTER //
// src/taskflex/students/components/search/StudentNameSearch.vue